export default "__VITE_ASSET__BwWGcwfJ__"